import {
    apiConstants,
    config,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverCatalogApi {
    static getResources(librarySearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(librarySearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `catalog/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }

    static getCopyBarcode(catalogCopyId: string) {
        return sendRequest(
            requestOptions(config.URL + `catalog/copy/${catalogCopyId}`,
                requestTypes.GET,
            ),
        );
    }

    static getResource(catalogId: string) {
        return sendRequest(
            requestOptions(config.URL + `catalog/${catalogId}`,
                requestTypes.GET,
            ),
        );
    }

    static getPublishers() {
        return sendRequest(
            requestOptions(config.URL + `catalog/publishers`,
                requestTypes.GET,
            ),
        );
    }

    static getVendors(systemType: string | number) {
        return sendRequest(
            requestOptions(config.URL + `vendors/system/${systemType}`,
                requestTypes.GET,
            ),
        );
    }

    static getWhatsNew(systemType: string | number) {
        return sendRequest(
            requestOptions(config.URL + `whatsnew/${systemType}`,
                requestTypes.GET,
            ),
        );
    }

    static saveFormat(format: Record<string, unknown>) {
        const requestType = format.catalogFormatId ? requestTypes.PUT : requestTypes.POST;
        const requestMessage = format.catalogFormatId
            ? apiConstants.successMessage.catalog.CATALOG_ITEM_UPDATED
            : apiConstants.successMessage.catalog.CATALOG_ITEM_ADDED;

        return sendRequest(
            requestOptions(config.URL + `catalog/formats`,
                requestType,
                JSON.stringify(format),
                requestMessage,
            ),
        );
    }

    static saveResource(resource: Record<string, unknown>) {
        const requestType = resource.catalogId ? requestTypes.PUT : requestTypes.POST;
        const requestMessage = resource.catalogId
            ? apiConstants.successMessage.catalog.CATALOG_ITEM_UPDATED
            : apiConstants.successMessage.catalog.CATALOG_ITEM_ADDED;

        return sendRequest(
            requestOptions(config.URL + `catalog`,
                requestType,
                JSON.stringify(resource),
                requestMessage,
            ),
        );
    }

    static savePublisher(publisher: Record<string, unknown>) {
        const requestType = publisher.publisherId ? requestTypes.PUT : requestTypes.POST;
        const requestMessage = publisher.publisherId
            ? apiConstants.successMessage.catalog.CATALOG_PUBLISHER_UPDATED
            : apiConstants.successMessage.catalog.CATALOG_PUBLISHER_ADDED;

        return sendRequest(
            requestOptions(config.URL + `catalog/publishers`,
                requestType,
                JSON.stringify(publisher),
                requestMessage,
            ),
        );
    }

    static saveVendor(vendor: Record<string, unknown>) {
        const requestType = vendor.vendorId ? requestTypes.PUT : requestTypes.POST;
        const requestMessage = vendor.vendorId
            ? apiConstants.successMessage.catalog.CATALOG_VENDOR_UPDATED
            : apiConstants.successMessage.catalog.CATALOG_VENDOR_ADDED;

        return sendRequest(
            requestOptions(config.URL + `vendors`,
                requestType,
                JSON.stringify(vendor),
                requestMessage,
            ),
        );
    }
}

export const libraryCatalogApi = serverCatalogApi;
